import React, { Component } from 'react';
import { Card } from 'antd';
import Process from '@comm/workflow/Process';
import ProcessHistory from '@comm/workflow/ProcessHistory';

import { queryRefundWorkflow } from '@api/incubator/refund';

import FormBase from './FormBase';

class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {},
      isSubmitting: false,
      instance: {
        activities: [],
        currentActivity: {},
      },
    };
  }

  componentDidMount() {
    const { dataInfo } = this.state;
    this.setState({ dataInfo });
    this.refundWorkflow();
  }

  refundWorkflow = params => {
    const { instance } = this.state;
    queryRefundWorkflow(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          instance: {
            ...instance,
            activities: res.data,
          },
        });
      }
    });
  };

  handleCompayChange = uuid => {
    this.refundWorkflow({
      company: uuid,
    });
  };

  render() {
    const { isSubmitting, instance } = this.state;
    const dataInfo = this.props.data;
    const histories = dataInfo.histories || [];
    return (
      <div>
        <FormBase
          data={this.props.data}
          isSubmitting={isSubmitting}
          onCompanyChange={this.handleCompayChange}
          {...this.props}
        />
        <Card>
          <Process instance={instance} />
          <div style={{ marginTop: '16px' }}>
            <ProcessHistory dataSource={histories} />
          </div>
        </Card>
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/incubator/refund/PageEdit.js